import Vue from 'vue'
import moment from 'moment'
moment.locale('id')

Vue.filter('getDateIndo',function(date){
    return moment(date).format("DD MMMM YYYY")
})

Vue.filter('getDateIndoWithDay',function(date){
    return moment(date).format("dddd, DD MMMM YYYY")
})

Vue.filter('getDateIndoWithDayAndTime',function(date){
    return moment(date).format("dddd, DD MMMM YYYY") + ' - Pukul ' + moment(date).format("hh:mm")
})

Vue.filter('getDiffDateIndo', function(date) {
    let given = moment(date, "YYYY-MM-DD")
    let current = moment().startOf('day')

    //Difference in number of days
    let diffDays = moment.duration(given.diff(current)).asDays()
    if (diffDays < 0) {
        return 'Sudah Terlaksana'
    } else if (diffDays > 0) {
        return `${diffDays} Hari Lagi`
    } else {
        return 'Hari Ini'
    }
})


